module.exports = __webpack_public_path__ + "static/media/founder.b7a7fc7d.jpg";